import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import _ from 'lodash';
import CreatePostButton from '../../components/create-post-button';
import EmptyStates from '../../components/empty-states';
import withPermissions from '../../hoc/with-permissions';
import withTranslate from '../../hoc/with-translate';

const NoPosts = ({ category, showCreatePostAction, t, ...props }) =>
  <EmptyStates title={t('category-page.no-posts-yet')} content={t('category-page.create-new-post')} {...props}>
    {showCreatePostAction && <CreatePostButton categorySlug={category.slug}/>}
  </EmptyStates>;

NoPosts.propTypes = {
  category: PropTypes.object,
  showCreatePostAction: PropTypes.bool,
  t: PropTypes.func,
};

const mapStateToProps = (state, { category, canSee }) => ({
  showCreatePostAction: category && (!category.isWriteProtected || canSee('create-post', 'category', category)),
});

export default _.flowRight(withPermissions, connect(mapStateToProps), withTranslate)(NoPosts);



// WEBPACK FOOTER //
// ./app/components/no-posts/no-posts.js